import script from "./SowASeed.vue?vue&type=script&setup=true&lang=js"
export * from "./SowASeed.vue?vue&type=script&setup=true&lang=js"

import "./SowASeed.vue?vue&type=style&index=0&id=6fa31ce0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fa31ce0"]])

export default __exports__